'use strict';

var KeyMirror = require('keymirror');

module.exports = {
    Values: {
        ANNUALLY: 'Y',
        QUARTERLY: 'Q'
    },
    ActionTypes: KeyMirror({
        SAVE_AUTO_REBALANCING: null,
        VALIDATE_AUTO_REBALANCING: null,
        RETRIEVE_AUTO_REBALANCING: null,
        UPDATE_AUTO_REBALANCING: null
    }),
    AutoRebalancingFields: {
        AUTO_REBALANCING_OPTIONS: 'ARO',
        FREQUENCY_OPTIONS: 'FO'
    },
    FrequencyData: [{ id: 'Y', name: 'Annually', isHidden: false }, { id: 'Q', name: 'Quarterly', isHidden: false }],
    Labels: {
        SETUP_AUTOREBALANCING: 'Set up auto-rebalancing',
        FREQUENCY: 'Frequency',
        FREQUENCY_ANNUALLY: 'Annually',
        FREQUENCY_QUARTERLY: 'Quarterly'
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/AutoRebalancingConstants.js